export function formatLastNChars(
  value: string,
  length: number,
  prefix = "#",
): string {
  if (value.length >= length) {
    return prefix + value.slice(-length);
  }
  return prefix + value;
}
